var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController, Keyboard, Events } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { ApiProvider } from '../../providers/api/api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
var CommonFooterComponent = /** @class */ (function () {
    function CommonFooterComponent(navCtrl, keyboard, events, comProv, apiProv, gaProv) {
        var _this = this;
        this.navCtrl = navCtrl;
        this.keyboard = keyboard;
        this.events = events;
        this.comProv = comProv;
        this.apiProv = apiProv;
        this.gaProv = gaProv;
        this.shop_data = [];
        this.service_data = [];
        this.footer_list = [];
        this.background_color = '#4e8ef7';
        this.drawer_list = [];
        this.is_pc = this.comProv.isPc();
        this.service_data = this.comProv.getService();
        this.is_android = this.comProv.isAndroid();
        this.year = (new Date()).getFullYear();
        this.company_name = this.service_data['name'];
        if (this.service_data['company_name']) {
            this.company_name = this.service_data['company_name'];
        }
        this.events.subscribe('drawer:set', function () {
            _this.setDrawer();
        });
    }
    CommonFooterComponent.prototype.ngOnInit = function () {
        this.setList();
        this.setDrawer();
    };
    CommonFooterComponent.prototype.setDrawer = function () {
        this.drawer_list = this.comProv.getDrawer();
        this.drawer_list = this.drawer_list.filter(function (item) { return item['is_privated'] != 1; });
        var info_rule = { title: '規約', page_target: 'InfoRulePage' };
        var info_privacy = { title: 'プライバシーポリシー', page_target: 'InfoPrivacyPage' };
        this.drawer_list.push(info_rule);
        this.drawer_list.push(info_privacy);
    };
    CommonFooterComponent.prototype.setList = function () {
        if (!localStorage.getItem('footer_list') || localStorage.getItem('footer_list') == '') {
            return;
        }
        var footer_color = '#ffffff';
        if (localStorage.getItem('footer_color')) {
            footer_color = localStorage.getItem('footer_color');
        }
        var footer_inactive_color = '#b3b3b3';
        if (localStorage.getItem('footer_inactive_color')) {
            footer_inactive_color = localStorage.getItem('footer_inactive_color');
        }
        if (localStorage.getItem('footer_background_color')) {
            this.background_color = localStorage.getItem('footer_background_color');
        }
        var footer_list = JSON.parse(localStorage.getItem('footer_list'));
        for (var i = 0; i < footer_list.length; i++) {
            if (footer_list[i]['target'] == this.page) {
                footer_list[i]['text_color'] = footer_color;
            }
            else {
                footer_list[i]['text_color'] = footer_inactive_color;
            }
            if (footer_list[i]['icon']) {
                footer_list[i]['icon'] = footer_list[i]['icon'].replace('fab ', 'fab-tenpo ');
            }
        }
        this.footer_list = footer_list;
        this.setCouponBadge();
    };
    CommonFooterComponent.prototype.goPage = function (item) {
        var data = {
            url: item['url'],
            target: item['target'],
            current_page: this.page,
            category: 'フッターメニュー'
        };
        this.comProv.goPage(data, this.navCtrl, this.gaProv);
    };
    CommonFooterComponent.prototype.goPagePc = function (item) {
        this.comProv.goPagePc(item, this.navCtrl, this.page);
        /*if (item['page_url']) {
          this.comProv.checkLink(item['page_url'], this.navCtrl);
        } else if (item['page_target'] == 'HomePage') {
          this.navCtrl.setRoot('home');
        } else if (item['page_target'].indexOf('FreeIndexPage-') === 0) {
          let targets = item['page_target'].split('-');
          this.navCtrl.setRoot(targets[0], {free_id:targets[1]});
        } else if (item['is_scroll']) {
          this.scrollTo(item['page_target']);
        } else if (item['page_target']) {
          this.navCtrl.setRoot(item['page_target']);
        }*/
    };
    /*scrollTo(id) {
      if (this.page == 'HomePage') {
        let element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      } else {
        this.navCtrl.setRoot('home',{scroll_id:id});
      }
    }*/
    CommonFooterComponent.prototype.mouseOver = function (item) {
        var color_list = this.comProv.getColor();
        item['color'] = color_list['button_background'];
    };
    CommonFooterComponent.prototype.mouseOut = function (item) {
        item['color'] = '#000000';
    };
    CommonFooterComponent.prototype.checkCouponBadge = function () {
        var find_coupon = this.footer_list.findIndex(function (footer_data) {
            return (footer_data['target'] == 'CouponIndexPage');
        });
        if (find_coupon === -1) {
            return false;
        }
        return true;
    };
    CommonFooterComponent.prototype.setCouponBadge = function () {
        if (!this.checkCouponBadge()) {
            return;
        }
        // クーポンバッジ削除
        if (this.page == 'CouponIndexPage') {
            this.comProv.setOptions('is_coupon_badge', 0);
            this.comProv.setOptions('last_coupon_display_time', this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss'));
            return;
        }
        if (this.comProv.getOptionsValue('is_coupon_badge')) {
            this.is_coupon_badge = true;
        }
    };
    CommonFooterComponent.prototype.getLatestCoupon = function () {
        var _this = this;
        if (!this.checkCouponBadge()) {
            return;
        }
        this.apiProv.get(this.service_data['_links']['latest_coupon']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            var latest_coupon_at = data['latest_coupon_at'];
            //console.log('latest_coupon_at', latest_coupon_at);
            if (!latest_coupon_at) {
                _this.comProv.setOptions('is_coupon_badge', 0);
                return;
            }
            var last_coupon_display_time = _this.comProv.getOptionsValue('last_coupon_display_time');
            //console.log('last_coupon_display_time', last_coupon_display_time);
            var is_coupon_badge = _this.comProv.checkTime(last_coupon_display_time, latest_coupon_at);
            if (is_coupon_badge) {
                _this.is_coupon_badge = true;
                _this.comProv.setOptions('is_coupon_badge', 1);
            }
        }).catch(function (error) {
            //this.apiProv.statusError(error, this.navCtrl);
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CommonFooterComponent.prototype, "page", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CommonFooterComponent.prototype, "site_flg", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], CommonFooterComponent.prototype, "shop_data", void 0);
    CommonFooterComponent = __decorate([
        Component({
            selector: 'common-footer',
            templateUrl: 'common-footer.html',
        }),
        __metadata("design:paramtypes", [NavController,
            Keyboard,
            Events,
            CommonProvider,
            ApiProvider,
            AnalyticsProvider])
    ], CommonFooterComponent);
    return CommonFooterComponent;
}());
export { CommonFooterComponent };
//# sourceMappingURL=common-footer.js.map


// WEBPACK FOOTER //
// ./src/components/common-footer/common-footer.ts.pre-build-optimizer.js